export const LEGACY_CALL_OBJECT_UUID_PROPERTY = 'hs_call_zoom_meeting_uuid';
export const CALL_UNIQUE_EXTERNAL_ID_PROPERTY = 'hs_call_unique_external_id';